import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_SCT_FIXED_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_SCT_FIXED> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_SCT_FIXED,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_SCT_FIXED);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_SCT_FIXED> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_SCT_FIXED = {
	date2Year: 'year2',
	date1Year: 'year',
	title2: 'title2',
	name2: 'Name2',
	signature2: 'signature2',
	signature1: 'signature',
	name1: 'name',
	title1: 'title',
	date2Month: 'day of_2',
	date2Day: 'DATED the_2',
	date1Month: 'day of',
	date1Day: 'DATED the',
	chargors: 'chargors names',
	guarantors: 'guarantors',
	// "12":"25 year rate",
	// "13":"143 months and 1 day and over",
	// "14":"10 year rate",
	// "15":"95 months and 1 day  143 months",
	// "16":"7 year rate",
	// "17":"71 months and 1 day  95 months",
	// "18":"5 year rate",
	// "19":"53 months and 1 day  71 months",
	// "20":"4 year rate",
	// "21":"41 months and 1 day  53 months",
	// "22":"3 year rate",
	// "23":"29 months and 1 day  41 months",
	// "24":"2 year rate",
	// "25":"17 months and 1 day  29 months",
	// "26":"1 year rate",
	// "27":"8 months and 1 day  17 months",
	// "28":"6 month rate",
	// "29":"0 months  8 months",
	// "30":"USE FOLLOWING RATES",
	// "31":"TERM REMAINING"
};

export interface RBC_RESIDENTIAL_SCT_FIXED {
	date1Day: string;
	date1Month: string;
	date1Year: string;

	chargors: string;

	date2Day: string;
	date2Month: string;
	date2Year: string;

	guarantors: string;

	signature1: string;
	name1: string;
	title1: string;

	signature2: string;
	name2: string;
	title2: string;
}
